export default {
  MuiInputBase: {
    styleOverrides: {
      root: {
        minHeight: '40px',
        borderRadius: '2px'
      },
      input: {
        fontSize: '1rem',
        padding: '10px 15px'
      },
      multiline: {
        padding: '0px !important',
        lineHeight: '32px'
      }
    }
  },
  MuiInput: {
    styleOverrides: {
      input: {
        '&::placeholder': {
          color: '#6d7278'
        }
      },
      underline: {
        '&:before': {
          borderBottomColor: 'rgba(0,0,0,0)',
          borderBottom: 'none',
          borderWidth: 2
        },
        '&:after': {
          borderBottomColor: 'rgba(0,0,0,0)',
          borderBottom: 'none',
          borderWidth: 2
        },
        '&:hover:not($disabled):before': {
          borderBottomColor: 'rgba(0,0,0,0)',
          borderBottom: 'none',
          borderWidth: 2
        }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: '2px',
        '&$focused': {
          border: 'none',
          borderBottom: 'none'
        },
        '&$focused $notchedOutline': {
          border: 'solid 1px #bcbcbc',
          borderColor: '#bcbcbc',
          borderWidth: 1
        },
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          border: 'solid 1px #bcbcbc',
          borderColor: '#bcbcbc',
          borderWidth: 1
        }
      },
      notchedOutline: {
        borderRadius: '4px',
        borderColor: '#D9D9D9'
      },
      input: {
        padding: '12.5px 16px'
      },
      adornedEnd: {
        paddingRight: '0px'
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        '&$disabled': {
          backgroundColor: '#f7f7f7'
        },
        borderBottom: 'none',
        '&.Mui-focused::after': {
          borderBottomStyle: 'none !important',
          transform: 'scaleX(0)'
        },
        minHeight: '36px',
        '&.Mui-disabled': {
          backgroundColor: '#F5F5F5'
        }
      },
      input: {
        color: '#000000',
        padding: '12.5px 16px'
      },
      multiline: {
        padding: '8px 12px'
      },
      underline: {
        '&:before': {
          borderBottom: 'none !important'
        },
        '&&&:before': {
          borderBottomStyle: 'none !important'
        }
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        '&$focused': {
          color: '#0091ff'
        }
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      contained: {
        marginLeft: '0px',
        marginTop: '5px'
      }
    }
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        height: 'auto'
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionStart: {
        marginTop: '0px !important'
      }
    }
  }
};
